module.exports = __webpack_public_path__ + "img/icon-tick.772d4e7d.svg";